module.exports = __webpack_public_path__ + "static/media/group--material-condition.3e5b4014.svg";